import { Directive, Input, TemplateRef, ViewContainerRef, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Directive({
  selector: '[appHasRole]',
  standalone: true
})
export class HasRoleDirective implements OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly templateRef = inject(TemplateRef<any>);
  private readonly viewContainer = inject(ViewContainerRef);
  
  private hasView = false;
  private role: string | string[] = [];
  private readonly subscription?: Subscription;

  @Input() set appHasRole(role: string | string[]) {
    this.role = role;
    this.updateView();
  }

  constructor() {
    this.subscription = this.authService.userRoles$.subscribe(() => {
      this.updateView();
    });
  }

  private updateView() {
    if (!this.role) return;
    
    const rolesToCheck = Array.isArray(this.role) ? this.role : [this.role];
    const hasRole = rolesToCheck.some(r => this.authService.hasRole(r));
    
    if (hasRole && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasRole && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
